<template>
  <div class="evaluateList">
    <van-tabs sticky @click="onClick" v-model="active">
      <van-tab v-for="(item,index) in tabs" :title="item" :key="index + 'tabs'">
        <div class="content">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <div
              class="list"
              v-for="item in envaluateList"
              :key="item.id "
              @click.stop=" active == 0 ? '' : goDetail(item.evaluate_id)"
            >
              <div class="top flex justify_between">
                <div class="title">订单编号：{{item.chain_order_sn}}</div>
                <div class="status">已完成</div>
              </div>
              <div class="goods flex">
                <img class="goods_img" :src="item.goods_image" alt />
                <div class="goods_content">
                  <div class="goods_title">{{item.goods_name}}</div>
                  <div class="goods_sku">规格：{{item.sku_name}}</div>
                  <div class="goods_f flex alitem_center" v-if="active == 1">
                    <p>商品评分</p>
                    <van-rate v-model="item.evaluate_goods_score" readonly />
                  </div>
                  <div class="goods_f flex alitem_center justify_between" v-if="active == 0">
                    <p></p>
                    <div class="envalue_btn" @click="jump(item.id)">评价</div>
                  </div>
                </div>
              </div>
              <div class="evaluate" v-if="active == 1">{{item.evaluate_content}}</div>
              <div class="evaluate_img flex" v-if="active == 1">
                <img
                  v-for="(titem,idnex) in item.evaluate_image"
                  :src="titem"
                  alt
                  :key="idnex"
                  @click.stop="openImagesFg(item.evaluate_image,idnex)"
                />
              </div>
            </div>
          </van-list>
        </div>
      </van-tab>
    </van-tabs>
    <van-image-preview :startPosition="canvasImg" v-model="isShowImgs" :images="images"></van-image-preview>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: ['待评价', '已评价'],
      value: 2,
      envaluateList: [],
      page: 0,
      loading: false,
      finished: false,
      active: 0,
      list: [],
      isShowImgs: false,
      images: [],
      canvasImg: 0,
    }
  },
  methods: {
    openImagesFg(e, index) {
      this.canvasImg = index
      console.log(e)
      this.images = e
      this.isShowImgs = true
    },
    goDetail(id) {
      this.$router.push({ path: 'evaluateDetail', query: { id: id } })
    },
    onClick(name, title) {
      this.page = 0
      this.envaluateList = []
      this.onLoad()
    },
    onLoad() {
      this.page++
      this.getEvaluateOrders()
    },
    getEvaluateOrders() {
      this.http('ClientOrder.evaluateOrders', {
        page: this.page,
        limit: 20,
        type: Number(this.active) + 1,
      }).then((res) => {
        this.loading = false
        console.log(res)
        // if (res.status == 200) {
        this.envaluateList = [...this.envaluateList, ...res.content.list]
        this.finished = this.envaluateList.length == res.content.count
        // }
      })
    },
    jump(id) {
      this.$router.push({ path: 'evaluateEdit', query: { id: id } })
    },
  },
}
</script>

<style lang="scss" scoped>
.alitem_center {
  align-items: center;
}
.justify_between {
  justify-content: space-between;
}
.evaluateList {
  background: rgba(247, 248, 250, 1);
  .content {
    padding: 20px;
    .list {
      background: #ffffff;
      border-radius: 20px;
      margin-bottom: 20px;
      padding-bottom: 40px;
      .top {
        padding: 20px 40px;
        border-bottom: 1px solid rgba(241, 241, 241, 1);
        .title {
          font-size: 28px;
          color: #333333;
        }
        .status {
          font-size: 28px;
          color: #999999;
        }
      }
      .goods {
        padding: 20px 40px;
        .goods_img {
          width: 160px;
          height: 160px;
        }
        .goods_content {
          width: 100%;
          margin-left: 20px;
          .goods_title {
            font-size: 26px;
            color: #333333;
            font-weight: 700;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .goods_sku {
            font-size: 22px;
            color: #999999;
            padding: 10px 0;
          }
          .goods_f {
            p {
              font-size: 28px;
              color: #333333;
              margin-right: 20px;
            }
          }
        }
      }
      .evaluate {
        padding: 20px 40px;
        font-size: 22px;
        color: #666666;
        line-height: 36px;
      }
      .evaluate_img {
        padding-left: 40px;
        img {
          width: 110px;
          height: 110px;
          border-radius: 20px;
          margin-right: 20px;
        }
      }
    }
  }
}
.envalue_btn {
  width: 172px;
  height: 62px;
  line-height: 62px;
  border-radius: 31px;
  background: rgba(255, 51, 51, 1);
  font-size: 28px;
  color: #ffffff;
  text-align: center;
}
</style>